import { useFormField } from '../../../../hooks/useFormField/useFormField.js';

var useTextareaFormField = function useTextareaFormField(props) {
  var _useFormField = useFormField(props),
    rootProps = _useFormField.rootProps,
    textareaProps = _useFormField.textareaProps,
    clearButtonProps = _useFormField.clearButtonProps,
    controlContainerProps = _useFormField.controlContainerProps,
    validationMessageProps = _useFormField.validationMessageProps,
    utilityProps = _useFormField.utilityProps;
  return {
    rootProps: rootProps,
    textareaProps: textareaProps,
    clearButtonProps: clearButtonProps,
    controlContainerProps: controlContainerProps,
    validationMessageProps: validationMessageProps,
    utilityProps: utilityProps
  };
};

export { useTextareaFormField };
//# sourceMappingURL=useTextareaFormField.js.map
